import AdminDashboard from "../components/AdminDashboard"; 
const AdminDashBoard = ()=>{
  return(
	 <AdminDashboard />
  ); 
}
export default AdminDashBoard; 
